export default __webpack_public_path__ + "static/media/contact-form-icon-white.2c37739b.svg";